import 'react-select/dist/react-select.css'
import 'react-virtualized/styles.css'
import 'react-virtualized-select/styles.css'
import VirtualizedSelect from 'react-virtualized-select'
import ReactSelect from 'react-select'
import classNames from 'classnames'
import SearchInput from '../SearchInput'
import MultiOptionRenderer from './MultiOptionRenderer'
import MultiSelectionRenderer from './MultiSelectionRenderer'
import {createFilter} from 'react-search-input'
import './Select.less'
import PropTypes from 'prop-types'
import React from 'react'

// Temporary hack so that we can access the reactselect instance
let reactSelectRef

/**
 * Convenience wrapper
 * Used in order to be able to override handleInputBlur
 */
class SelectWrapper extends React.Component {
  /**
   * Overrides ReactSelect's handleInputBlur when component is searchable
   * for not closing outer-menu when user clicks on search input
   */
  componentDidMount () {
    const ReactSelect = this.refs.ReactSelect
    reactSelectRef = ReactSelect
    if (ReactSelect) {
      const originalHandleInputBlur = ReactSelect.handleInputBlur
      ReactSelect.handleInputBlur = function (event) {
        if (
          event.relatedTarget &&
          event.relatedTarget.parentElement &&
          event.relatedTarget.parentElement.className === 'infra-select__search-input'
        ) {
          event.preventDefault()
          event.stopPropagation()
        } else {
          originalHandleInputBlur(event)
        }
      }
    }
  }
  render () {
    return <ReactSelect
      {...this.props}
      ref='ReactSelect'
    />
  }
}

function nmcArrowRenderer () {
  return <span className='nmc-select-arrow' />
}

/**
 * Select-box component
 * It wraps React-Select component and overrides it's search functionality
 */
export default class Select extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isOpen: false,
      searchTerm: ''
    }
    this.onSearchChange = this.onSearchChange.bind(this)
    this.onSearchBlur = this.onSearchBlur.bind(this)
    this.filterOptions = this.filterOptions.bind(this)
    this.onOpen = this.onOpen.bind(this)
    this.onClose = this.onClose.bind(this)
    this.getSearchInput = this.getSearchInput.bind(this)
  }
  onSearchChange (searchTerm) {
    if (this.props.handleSearchChange) {
      this.props.handleSearchChange(searchTerm)
    }
    this.setState({searchTerm: searchTerm})
  }
  /**
   * Closes menu-outer on search-input blur
   */
  onSearchBlur () {
    reactSelectRef.closeMenu()
  }
  /**
   * Filters option based on searchTerm or calls customFilterOptions prop function
   * @returns {*}
   */
  filterOptions () {
    if (this.props.customFilterOptions) {
      return this.props.customFilterOptions(this.state.searchTerm, this.props.options)
    }
    return this.props.options.filter(createFilter(this.state.searchTerm, this.props.keysToFilter))
  }
  onOpen () {
    if (this.props.onOpen) {
      this.props.onOpen(arguments)
    }
    this.setState({isOpen: true})
  }
  onClose () {
    this.onOpen()
    if (this.props.onClose) {
      this.props.onClose(arguments)
    }
    this.setState({isOpen: false})
  }
  /**
   * Returns search input component, if Select is searchable
   * @returns {*}
   */
  getSearchInput () {
    if (this.props.searchable && this.state.isOpen) {
      return <SearchInput
        onBlur={this.onSearchBlur}
        value={this.state.searchTerm}
        className='infra-select__search-input'
        placeholder={this.props.searchPlaceholder}
        onChange={this.onSearchChange}
      />
    } else {
      return null
    }
  }

  render () {
    const filteredOptions = this.filterOptions()
    const arrowRenderer = this.props.arrowRenderer || ((this.props.className && this.props.className.split(' ').includes('nmc-select')) ? nmcArrowRenderer : undefined)
    let value = this.props.value
    let optionRenderer = this.props.optionRenderer
    let valueRenderer = this.props.valueRenderer
    if (this.props.checkboxedMulti) {
      optionRenderer = MultiOptionRenderer(this.props.onChange)
      valueRenderer = MultiSelectionRenderer(this.props.placeholder)
      value = {options: this.props.options} // will be later passed to our valueRenderer by react-select. also see: unwrapOptions
    }
    return (
      <div className={classNames(
        'infra-select',
        this.props.className,
        {'infra-select_is-searchable': this.props.searchable})}
        style={this.props.style}
      >
        <VirtualizedSelect
          {...this.props}
          arrowRenderer={arrowRenderer}
          optionRenderer={optionRenderer}
          valueRenderer={valueRenderer}
          selectComponent={SelectWrapper}
          className={classNames('infra-select__Select', {'infra-select__Select_is-opened': this.state.isOpen})}
          options={filteredOptions}
          value={value}
          searchable={false}
          onOpen={this.onOpen}
          onClose={this.onClose}
          style={{}}
          ref='VirtualizedSelect'
        />
        {this.getSearchInput()}
      </div>
    )
  }
}

Select.propTypes = {
  // All props of ReactSelect and:
  keysToFilter: PropTypes.array,        // by which keys you want to filter options (default: label)
  customFilterOptions: PropTypes.func,  // custom filter function, which will filter options on search
                                        // (not using filterOptions prop name, because it has collision with
                                        // default VirtualizedSelect filter function)
  options: PropTypes.array,             // array of options
  searchable: PropTypes.bool,           // should this component be searchable or not
  disabled: PropTypes.bool,             // is this select disabled or not
  searchPlaceholder: PropTypes.string,  // placeholder for search input
  placeholder: PropTypes.string,        // prompt for when there's no selection
  onOpen: PropTypes.func,               // function, which will be called when the menu-outer is opened
  onClose: PropTypes.func,              // function, which will be called when the menu-outer is closed
  onChange: PropTypes.func,             // function, which will be called when the selection is changed
  handleSearchChange: PropTypes.func,   // function, which can handle search change from parent component
  checkboxedMulti: PropTypes.bool       // TODO: in the future maybe extract this to a composite component (suggested by Vlad while code reviewing)
}

Select.defaultProps = {
  searchable: false,
  disabled: false,
  searchPlaceholder: 'search',
  placeholder: 'select...',
  options: [],
  keysToFilter: ['label'],
  checkboxedMulti: false
}



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/Select/index.js